const ENABLED_VAR = 'REACT_APP_ANALYTICS_ENABLED';
const SESSION_RECORDING_VAR = 'REACT_APP_DISABLE_SESSION_RECORDING';

const parseBool = (varName: string, raw: string | undefined): boolean => {
  if (raw === undefined) return false;

  const normalized = raw.trim().toLowerCase();

  if (normalized === '') return false;
  if (normalized === 'true') return true;
  if (normalized === 'false') return false;

  console.warn(
    `[Analytics] ${varName}="${raw}" is not 'true' or 'false' — treating as false. Check for typo / whitespace.`,
  );

  return false;
};

// CRA inlines REACT_APP_* env vars at build time, so these values cannot
// change at runtime. Resolve + warn once at module load instead of on every
// caller render.
const ANALYTICS_ENABLED = parseBool(ENABLED_VAR, process.env.REACT_APP_ANALYTICS_ENABLED);
const SESSION_RECORDING_DISABLED = parseBool(
  SESSION_RECORDING_VAR,
  process.env.REACT_APP_DISABLE_SESSION_RECORDING,
);

export const isAnalyticsEnabled = (): boolean => ANALYTICS_ENABLED;

export const isSessionRecordingDisabled = (): boolean => SESSION_RECORDING_DISABLED;
